/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/9.png";
import team2 from "assets/images/10.webp";
import team3 from "assets/images/11.png";
import team4 from "assets/images/12.png";
import team5 from "assets/images/13.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Our Mobile App Development & Maintenance Services?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
            At HP Tech Solutions , we're more than just a software development and cybersecurity service provider—we're your trusted partner in the digital world. Our mission is to deliver innovative, secure, and scalable solutions that help businesses grow, evolve, and thrive in an ever-changing technological landscape.

Founded by a team of experienced professionals, we combine deep expertise in software engineering with advanced cybersecurity strategies to solve complex challenges for businesses of all sizes. From custom software development to robust security frameworks, we offer a full suite of services tailored to meet your unique needs.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Cross-Platform Expertise"
                position={{ color: "info", label: "user-friendly" }}
                description="Whether you need an app for Android, iOS, or both, our development process ensures consistency and high performance across platforms."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="User-Centric Design"
                position={{ color: "info", label: "User-Centric" }}
                description="We prioritize user experience and design to create apps that are not only functional but also engaging and easy to use."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="End-to-End Services"
                position={{ color: "info", label: "End-to-End" }}
                description="From development to post-launch maintenance and updates, we provide a full suite of services to ensure your app is always up to date, secure, and optimized."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Scalability & Flexibility"
                position={{ color: "info", label: "Scalability" }}
                description="Our apps are built to scale as your user base grows and your needs evolve."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team5}
                name="Performance-First Approach"
                position={{ color: "info", label: "Performance" }}
                description="We focus on creating apps that are fast, responsive, and reliable under all conditions."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
